// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* custom-datepicker.css */
.react-datepicker {
  font-family: inherit;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  background-color: white;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  padding: 1rem;
}

.react-datepicker__header {
  background-color: transparent;
  border-bottom: none;
  padding-top: 0;
  padding-bottom: 0;
}

.react-datepicker__day-names {
  display: flex;
  justify-content: space-between;
}

.react-datepicker__month {
  margin: 0;
}

.react-datepicker__week {
  display: flex;
  justify-content: space-between;
}

.custom-day-wrapper {
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-day-button {
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid transparent;
  background-color: transparent;
  color: #2d3748;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s;
}

.custom-day-button:hover {
  background-color: #edf2f7;
}

.custom-day-button.selected {
  background-color: #4299e1;
  color: white;
}

.custom-day-button.other-month {
  color: #a0aec0;
  pointer-events: none;
}

.custom-input {
  padding: 0.5rem 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.375rem;
  font-size: 1rem;
  color: #2d3748;
  width: 100%;
}

.custom-input:focus {
  outline: none;
  border-color: #4299e1;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
}

.custom-weekday {
  color: #718096;
  font-size: 0.875rem;
}


.react-datepicker {
  font-family: inherit;
}

.react-datepicker__header {
  background-color: transparent;
  border-bottom: none;
}

.react-datepicker__day-name, .react-datepicker__day {
  margin: 0;
  padding: 0;
  width: auto;
  line-height: inherit;
}

.react-datepicker__day-name {
  color: #718096;
  width: 2.5rem !important;
  line-height: 2.5rem;
  margin: 0;
  text-align: center;
}

.react-datepicker__day {
  color: inherit;
  background-color: transparent;
}

.react-datepicker__day:hover {
  background-color: transparent;
}

.react-datepicker__day--selected,
.react-datepicker__day--keyboard-selected {
  background-color: transparent;
  color: inherit;
}

.react-datepicker__day--today {
  font-weight: normal;
}

.react-datepicker__day-names {
  margin-bottom: 0;
}

.react-datepicker__week {
  display: flex;
}

.react-datepicker__day-name {
  color: inherit;
}

.react-datepicker__day-wrapper {
  width: 2.5rem;
  height: 2.5rem;
}

.react-datepicker__day {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  margin: 0.25rem;
  padding: 0;
}

.react-datepicker__day-name {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem !important;
  height: 1.5rem;
  margin: 0;
  padding: 0;
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/customdatepicker.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,iFAAiF;EACjF,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;;AAGA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,cAAc;EACd,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB","sourcesContent":["/* custom-datepicker.css */\r\n.react-datepicker {\r\n  font-family: inherit;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 0.5rem;\r\n  background-color: white;\r\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\r\n  padding: 1rem;\r\n}\r\n\r\n.react-datepicker__header {\r\n  background-color: transparent;\r\n  border-bottom: none;\r\n  padding-top: 0;\r\n  padding-bottom: 0;\r\n}\r\n\r\n.react-datepicker__day-names {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.react-datepicker__month {\r\n  margin: 0;\r\n}\r\n\r\n.react-datepicker__week {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.custom-day-wrapper {\r\n  width: 2.5rem;\r\n  height: 2.5rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.custom-day-button {\r\n  width: 2rem;\r\n  height: 2rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 50%;\r\n  border: 1px solid transparent;\r\n  background-color: transparent;\r\n  color: #2d3748;\r\n  font-size: 0.875rem;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.custom-day-button:hover {\r\n  background-color: #edf2f7;\r\n}\r\n\r\n.custom-day-button.selected {\r\n  background-color: #4299e1;\r\n  color: white;\r\n}\r\n\r\n.custom-day-button.other-month {\r\n  color: #a0aec0;\r\n  pointer-events: none;\r\n}\r\n\r\n.custom-input {\r\n  padding: 0.5rem 1rem;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 0.375rem;\r\n  font-size: 1rem;\r\n  color: #2d3748;\r\n  width: 100%;\r\n}\r\n\r\n.custom-input:focus {\r\n  outline: none;\r\n  border-color: #4299e1;\r\n  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);\r\n}\r\n\r\n.custom-weekday {\r\n  color: #718096;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n\r\n.react-datepicker {\r\n  font-family: inherit;\r\n}\r\n\r\n.react-datepicker__header {\r\n  background-color: transparent;\r\n  border-bottom: none;\r\n}\r\n\r\n.react-datepicker__day-name, .react-datepicker__day {\r\n  margin: 0;\r\n  padding: 0;\r\n  width: auto;\r\n  line-height: inherit;\r\n}\r\n\r\n.react-datepicker__day-name {\r\n  color: #718096;\r\n  width: 2.5rem !important;\r\n  line-height: 2.5rem;\r\n  margin: 0;\r\n  text-align: center;\r\n}\r\n\r\n.react-datepicker__day {\r\n  color: inherit;\r\n  background-color: transparent;\r\n}\r\n\r\n.react-datepicker__day:hover {\r\n  background-color: transparent;\r\n}\r\n\r\n.react-datepicker__day--selected,\r\n.react-datepicker__day--keyboard-selected {\r\n  background-color: transparent;\r\n  color: inherit;\r\n}\r\n\r\n.react-datepicker__day--today {\r\n  font-weight: normal;\r\n}\r\n\r\n.react-datepicker__day-names {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.react-datepicker__week {\r\n  display: flex;\r\n}\r\n\r\n.react-datepicker__day-name {\r\n  color: inherit;\r\n}\r\n\r\n.react-datepicker__day-wrapper {\r\n  width: 2.5rem;\r\n  height: 2.5rem;\r\n}\r\n\r\n.react-datepicker__day {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 2rem;\r\n  height: 2rem;\r\n  margin: 0.25rem;\r\n  padding: 0;\r\n}\r\n\r\n.react-datepicker__day-name {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 2.5rem !important;\r\n  height: 1.5rem;\r\n  margin: 0;\r\n  padding: 0;\r\n  font-weight: 400;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
